import React from 'react';
import PropTypes from 'prop-types';

import planStatuses from 'data/policy_plan_statuses';

const statusName = (value) => {
  const status = planStatuses.find((item) => item.value === value);
  return status == null ? '' : status.label;
};

export default function Status({ status }) {
  const bgClass = {
    active: 'bg-primary',
    draft: 'bg-tertiary-1000',
    expired: 'bg-gray-700',
    trial_cancelled: 'bg-gray-700',
    cancelled: 'bg-gray-700',
  };

  return (
    <div className={`status d-inline-block me-2 p-2 pt-3 text-white ${bgClass[status]}`}>
      {statusName(status)}
    </div>
  );
}

Status.propTypes = {
  status: PropTypes.string.isRequired,
};
